import styled from "styled-components";
import { colors } from "../../../components/common/element/elements.js";

export const Styles = styled.div`
  .blog-sidebar {
    .widget {
      background: #fff;
      border: 1px solid ${colors.border1};
      border-radius: 6px;
      padding: 24px;
      margin-bottom: 25px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);

      &:last-child {
        margin-bottom: 0;
      }

      h5 {
        font-size: 16px;
        font-weight: 600;
        color: ${colors.black1};
        margin-bottom: 18px;
        position: relative;
        padding-bottom: 8px;

        &:after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 40px;
          height: 3px;
          background: ${colors.red};
        }
      }

      .muted {
        color: ${colors.text3};
        font-size: 14px;
        margin: 0;
      }
    }

    .search-widget {
      form {
        .input-group {
          input {
            border-radius: 4px 0 0 4px;
          }

          button {
            border-radius: 0 4px 4px 0;
            background: ${colors.red_bg};
            border: none;
            font-weight: 600;
            text-transform: uppercase;

            &:hover {
              background: ${colors.red_bg2};
            }
          }
        }
      }
    }

    .recent-posts-widget {
      ul {
        margin: 0;
        padding: 0;

        li {
          list-style: none;
          margin-bottom: 15px;

          &:last-child {
            margin-bottom: 0;
          }

          a {
            display: flex;
            flex-direction: column;
            text-decoration: none;
            color: ${colors.black1};

            .title {
              font-size: 15px;
              font-weight: 500;
              margin-bottom: 4px;
              line-height: 1.4;
            }

            .date {
              font-size: 12px;
              color: ${colors.text3};
              text-transform: uppercase;
            }

            &:hover {
              color: ${colors.red};
            }
          }
        }
      }
    }

    .tag-widget {
      .tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        button {
          border: 1px solid ${colors.border3};
          background: ${colors.bg2};
          color: ${colors.black1};
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: ${colors.red};
            border-color: ${colors.red};
            color: #fff;
          }
        }
      }
    }
  }

  @media (max-width: 991px) {
    .blog-sidebar {
      margin-top: 30px;
    }
  }
`;
